import moment from "moment";
import { fnumber } from "helper/Helper";
import _ from "lodash";
import { secureStorage } from "libs";
import receiptToArray from "./receiptToArray";

const posLoader = (payload) => {
  const account = secureStorage.getItem("account");
  const info = secureStorage.getItem("domainInfo");

  const payloads = Array.isArray(payload) ? payload : [payload];
  const feed = _.times(7, () => String.fromCharCode(10));

  const rowsToLines = (rows) => {
    const WIDTH = 32;
    const LABEL_W = 13;
    const SEP = ": ";
    const VAL_W = WIDTH - LABEL_W - SEP.length;
    const INDENT = " ".repeat(LABEL_W + SEP.length);

    const wrapValue = (value) => {
      const lines = [];
      const words = value.split(" ");
      let current = "";
      for (const word of words) {
        if ((current ? current + " " + word : word).length <= VAL_W) {
          current = current ? current + " " + word : word;
        } else {
          if (current) lines.push(current);
          current = word.length > VAL_W ? word.substring(0, VAL_W) : word;
        }
      }
      if (current) lines.push(current);
      return lines;
    };

    return rows.flatMap((item) => {
      if (!Array.isArray(item)) return [item + "\n"];
      if (item.length === 1) return [item[0] + "\n"];

      const label = item[0].toString().padEnd(LABEL_W);
      const isNumber = typeof item[1] === "number";
      let value;
      if (item[0] === "TGL TRANSAKSI") {
        value = moment(item[1])
          .format("DD MMM YYYY HH:mm:ss")
          .toUpperCase();
      } else if (isNumber) {
        value = "Rp." + fnumber(item[1]);
      } else {
        value = String(item[1] ?? "");
      }

      if (value.length <= VAL_W) {
        return [
          label + SEP + (isNumber ? value.padStart(VAL_W) : value) + "\n",
        ];
      } else {
        const wrapped = wrapValue(value);
        return [
          label + SEP + wrapped[0] + "\n",
          ...wrapped.slice(1).map((w) => INDENT + w + "\n"),
        ];
      }
    });
  };

  const buildReceipt = (title, rows, p) => {
    const lines = rowsToLines(rows);
    const footer = [];
    if (p.productId === 14) {
      footer.push("PLN menyatakan struk ini sebagai\n");
      footer.push("bukti pembayaran yang sah\n");
    }
    footer.push(`${String.fromCharCode(27)}4Loket : ${account.name}\n`);
    footer.push(
      `Powered by ${info ? info.appName : ""}${String.fromCharCode(27)}5`
    );

    return [
      String.fromCharCode(29) +
        "!" +
        String.fromCharCode(16) +
        title +
        String.fromCharCode(29) +
        "!" +
        String.fromCharCode(0),
      " \n\n",
      ...lines,
      "\n",
      ...footer,
      ...feed,
      String.fromCharCode(27) + "i",
    ];
  };

  const final = [];

  for (const p of payloads) {
    const title = p.receiptTitle || p.title;
    const body = p.body || p.receiptBody;
    const isMultiDetail = body.details && body.details.length > 0;

    if (!isMultiDetail) {
      const rows = !Array.isArray(body) ? receiptToArray(body) : body;
      final.push(...buildReceipt(title, rows, p));
    } else {
      const adminPerDetail = (body.admin?.value ?? 0) / (body.qty?.value || 1);
      body.details.forEach((detail) => {
        const rows = [];
        for (const key of Object.keys(body)) {
          if (["period", "standMeter", "qty"].includes(key)) continue;
          if (key === "details") {
            Object.keys(detail).forEach((dKey) => {
              if (["dueAmount", "penalty", "tax"].includes(dKey)) return;
              const field = detail[dKey];
              if (!field) return;
              rows.push([field.caption, field.value]);
            });
            continue;
          }
          if (key === "amount") {
            const amountPerDetail =
              (detail.dueAmount?.value ?? 0) +
              (detail.penalty?.value ?? 0) +
              (detail.tax?.value ?? 0);
            rows.push([body.amount.caption, amountPerDetail]);
          } else if (key === "admin") {
            rows.push([body.admin.caption, adminPerDetail]);
          } else if (key === "total") {
            const totalPerDetail =
              (detail.dueAmount?.value ?? 0) +
              (detail.penalty?.value ?? 0) +
              (detail.tax?.value ?? 0) +
              adminPerDetail;
            rows.push([body.total.caption, totalPerDetail]);
          } else if (key === "info") {
            rows.push([body[key]?.value]);
          } else {
            rows.push([body[key]?.caption, body[key]?.value]);
          }
        }
        final.push(...buildReceipt(title, rows, p));
      });
    }
  }

  return final;
};
export default posLoader;
